"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function kshingles(s, k) {
    const len = Math.ceil(s.length / k);
    return new Array(len).fill('').map((_, index) => s.slice(index * k, index * k + k));
}
exports.default = kshingles;
//# sourceMappingURL=kshingles.js.map